var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_html.js
// module id = 1039
// module chunks = 0